export const ROUTES = {
  root: '/',
  login: '/login',
  forbidden: '/forbidden',
  dashboards: '/dashboards',
  dashboardDesigner: (id = ':id') => `/dashboards/${id}/edit`,
  dashboardViewer: (id = ':id') => `/dashboards/${id}`,
  users: '/admin/users',
  roles: '/admin/roles',
  permissions: '/admin/permissions',
  audit: '/admin/audit',
  reports: '/reports',
  settings: '/settings',
  profile: '/profile',
} as const;
